import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=e96c7590&"
import script from "./Group.vue?vue&type=script&lang=ts&"
export * from "./Group.vue?vue&type=script&lang=ts&"
import style0 from "./Group.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports